export const environment_int: Environment = {
  production: false,
  amplitudeKey: '6c6f716f61b8503ffa3188efc9538a60',
  aiNocUrl: 'https://lytx-ainoc-web-dev.aws.drivecaminc.xyz',
  cohorts: 'https://cloud-lytx-cohorts-api-dev.aws.drivecaminc.xyz',
  commandScheduler:
    'https://cloud-lytx-commandscheduler-api-dev.aws.drivecaminc.xyz',
  deviceEncryptionKey:
    'https://cloud-lytx-deviceencryptionkey-api-dev.aws.drivecaminc.xyz',
  deviceEvent: 'https://cloud-lytx-deviceevent-api-dev.aws.drivecaminc.xyz',
  deviceHealth: 'https://cloud-lytx-devicehealth-api-dev.aws.drivecaminc.xyz',
  deviceHealthSyslogs:
    'https://cloud-lytx-devicehealth-syslogs-dev.aws.drivecaminc.xyz',
  deviceMonitoring:
    'https://cloud-lytx-devicemonitoring-api-dev.aws.drivecaminc.xyz',
  devicePhotos: 'https://cloud-lytx-install-photo-api-dev.aws.drivecaminc.xyz',
  liveImage: 'https://cloud-lytx-liveimage-api-dev.aws.drivecaminc.xyz',
  deviceView: 'https://cloud-lytx-admin-device-view-api-dev.aws.drivecaminc.xyz',
  deviceApi: 'https://cloud-lytx-aws-admin-device-api-dev.aws.drivecaminc.xyz',
  devicePrivacy:
    'https://cloud-lytx-device-privacystatus-api-dev.aws.drivecaminc.xyz',
  deviceSettings: 'https://cloud-lytx-devicesettings-api-dev.aws.drivecaminc.xyz',
  deviceShadow: 'https://cloud-lytx-deviceshadow-api-dev.aws.drivecaminc.xyz',
  entitySearch:
    'https://cloud-lytx-entitysearch-service-dev.aws.drivecaminc.xyz',
  firmwareUpdate:
    'https://cloud-lytx-device-firmwareupdate-api-dev.aws.drivecaminc.xyz',
  firmwareUpdateService:
    'https://cloud-lytx-device-firmwareupdate-service-dev.aws.drivecaminc.xyz',
  modularUpdate: 'https://cloud-lytx-modularupdate-api-dev.aws.drivecaminc.xyz',
  motionInterval:
    'https://cloud-lytx-motioninterval-api-dev.aws.drivecaminc.xyz',
  releases:
    'https://cloud-lytx-modularupdate-releasemanagement-api-dev.aws.drivecaminc.xyz',
  settingsUpdate:
    'https://cloud-lytx-devicesettings-bulkupdate-api-dev.aws.drivecaminc.xyz',
  versions:
    'https://cloud-lytx-modularupdate-versions-api-dev.aws.drivecaminc.xyz',
  dashboards: [
    {
      name: 'Vehicle Make Model Year Table',
      address:
        "https://vpc-device-health-gav7uxuvtr27wg55am2tld2jtq.us-west-2.es.amazonaws.com/_dashboards/app/dashboards?security_tenant=global#/view/dab19d80-2c16-11ee-8eac-8bc8986700fc?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:'2022-06-15T07:00:00.000Z',to:now))&_a=(description:'',expandedPanelId:c877a9be-200d-4fec-9817-388071775322,filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:'DCC%20Dashboard',viewMode:view)",
    },
  ],
  googleMapsApiKey: 'AIzaSyCXvP4hkdTA5m6sJwW6tM8FbZPcPNzAS_c',
  geofenceActivation:
    'https://cloud-lytx-device-geofence-api-dev.aws.drivecaminc.xyz',
  settingsHistory:
    'https://cloud-lytx-devicesettings-api-dev.aws.drivecaminc.xyz',
};

export const environment_stg: Environment = {
  production: false,
  amplitudeKey: '0ce8d31f932d2e494e70d7fcb5f6c720',
  aiNocUrl: 'https://lytx-ainoc-web-stg.aws.drivecam.net',
  cohorts: 'https://cloud-lytx-cohorts-api-stg.aws.drivecam.net',
  commandScheduler:
    'https://cloud-lytx-commandscheduler-api-stg.aws.drivecam.net',
  deviceEncryptionKey:
    'https://cloud-lytx-deviceencryptionkey-api-stg.aws.drivecam.net',
  deviceEvent: 'https://cloud-lytx-deviceevent-api-stg.aws.drivecam.net',
  deviceHealth: 'https://cloud-lytx-devicehealth-api-stg.aws.drivecam.net',
  deviceHealthSyslogs:
    'https://cloud-lytx-devicehealth-syslogs-stg.aws.drivecam.net',
  deviceMonitoring:
    'https://cloud-lytx-devicemonitoring-api-stg.aws.drivecam.net',
  devicePhotos: 'https://cloud-lytx-install-photo-api-stg.aws.drivecam.net',
  liveImage: 'https://cloud-lytx-liveimage-api-stg.aws.drivecam.net',
  deviceView: 'https://cloud-lytx-admin-device-view-api-stg.aws.drivecam.net',
  deviceApi: 'https://cloud-lytx-aws-admin-device-api-stg.aws.drivecam.net',
  devicePrivacy:
    'https://cloud-lytx-device-privacystatus-api-stg.aws.drivecam.net',
  deviceSettings: 'https://cloud-lytx-devicesettings-api-stg.aws.drivecam.net',
  deviceShadow: 'https://cloud-lytx-deviceshadow-api-stg.aws.drivecam.net',
  entitySearch: 'https://cloud-lytx-entitysearch-service-stg.aws.drivecam.net',
  firmwareUpdate:
    'https://cloud-lytx-device-firmwareupdate-api-stg.aws.drivecam.net',
  firmwareUpdateService:
    'https://cloud-lytx-device-firmwareupdate-service-stg.aws.drivecam.net',
  modularUpdate: 'https://cloud-lytx-modularupdate-api-stg.aws.drivecam.net',
  motionInterval: 'https://cloud-lytx-motioninterval-api-stg.aws.drivecam.net',
  releases:
    'https://cloud-lytx-modularupdate-releasemanagement-api-stg.aws.drivecam.net',
  settingsUpdate:
    'https://cloud-lytx-devicesettings-bulkupdate-api-stg.aws.drivecam.net',
  versions:
    'https://cloud-lytx-modularupdate-versions-api-stg.aws.drivecam.net',
  dashboards: [
    {
      name: 'Vehicle Make Model Year Table',
      address:
        "https://vpc-device-health-gav7uxuvtr27wg55am2tld2jtq.us-west-2.es.amazonaws.com/_dashboards/app/dashboards?security_tenant=global#/view/dab19d80-2c16-11ee-8eac-8bc8986700fc?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:'2022-06-15T07:00:00.000Z',to:now))&_a=(description:'',expandedPanelId:c877a9be-200d-4fec-9817-388071775322,filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:'DCC%20Dashboard',viewMode:view)",
    },
  ],
  googleMapsApiKey: 'AIzaSyCXvP4hkdTA5m6sJwW6tM8FbZPcPNzAS_c',
  geofenceActivation:
    'https://cloud-lytx-device-geofence-api-stg.aws.drivecam.net',
  settingsHistory: 'https://cloud-lytx-devicesettings-api-stg.aws.drivecam.net',
};

export const environment_prod: Environment = {
  production: true,
  amplitudeKey: '03c37d56a229714c13379bd7373a7b88',
  aiNocUrl: 'https://lytx-ainoc-web-prod.aws.drivecam.net',
  cohorts: 'https://cloud-lytx-cohorts-api-prod.aws.drivecam.net',
  commandScheduler:
    'https://cloud-lytx-commandscheduler-api-prod.aws.drivecam.net',
  deviceEncryptionKey:
    'https://cloud-lytx-deviceencryptionkey-api-prod.aws.drivecam.net',
  deviceEvent: 'https://cloud-lytx-deviceevent-api-prod.aws.drivecam.net',
  deviceHealth: 'https://cloud-lytx-devicehealth-api-prod.aws.drivecam.net',
  deviceHealthSyslogs:
    'https://cloud-lytx-devicehealth-syslogs-prod.aws.drivecam.net',
  deviceMonitoring:
    'https://cloud-lytx-devicemonitoring-api-prod.aws.drivecam.net',
  devicePhotos: 'https://cloud-lytx-install-photo-api-prod.aws.drivecam.net',
  liveImage: 'https://cloud-lytx-liveimage-api-prod.aws.drivecam.net',
  deviceView: 'https://cloud-lytx-admin-device-view-api-prod.aws.drivecam.net',
  deviceApi: 'https://cloud-lytx-aws-admin-device-api-prod.aws.drivecam.net',
  devicePrivacy:
    'https://cloud-lytx-device-privacystatus-api-prod.aws.drivecam.net',
  deviceSettings: 'https://cloud-lytx-devicesettings-api-prod.aws.drivecam.net',
  deviceShadow: 'https://cloud-lytx-deviceshadow-api-prod.aws.drivecam.net',
  entitySearch: 'https://cloud-lytx-entitysearch-service-prod.aws.drivecam.net',
  firmwareUpdate:
    'https://cloud-lytx-device-firmwareupdate-api-prod.aws.drivecam.net',
  firmwareUpdateService:
    'https://cloud-lytx-device-firmwareupdate-service-prod.aws.drivecam.net',
  modularUpdate: 'https://cloud-lytx-modularupdate-api-prod.aws.drivecam.net',
  motionInterval: 'https://cloud-lytx-motioninterval-api-prod.aws.drivecam.net',
  releases:
    'https://cloud-lytx-modularupdate-releasemanagement-api-prod.aws.drivecam.net',
  settingsUpdate:
    'https://cloud-lytx-devicesettings-bulkupdate-api-prod.aws.drivecam.net',
  versions:
    'https://cloud-lytx-modularupdate-versions-api-prod.aws.drivecam.net',
  dashboards: [
    {
      name: 'Vehicle Make Model Year Table',
      address:
        "https://vpc-device-health-c75huzgw4ov4mf44vyhnhbz6xe.us-west-2.es.amazonaws.com/_dashboards/app/dashboards?security_tenant=global#/view/a22240d0-2b3c-11ee-a2ed-61094f3c74f8?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:'2023-05-06T07:00:00.000Z',to:now))&_a=(description:'',expandedPanelId:'0e75241c-876d-4795-b052-d42ca2b14f50',filters:!(),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:''),timeRestore:!f,title:'DCC%20Dashboard',viewMode:view)",
    },
  ],
  googleMapsApiKey: 'AIzaSyCXvP4hkdTA5m6sJwW6tM8FbZPcPNzAS_c',
  geofenceActivation:
    'https://cloud-lytx-device-geofence-api-prod.aws.drivecam.net',
  settingsHistory:
    'https://cloud-lytx-devicesettings-api-prod.aws.drivecam.net',
};

export interface Environment {
  aiNocUrl: string;
  settingsHistory: string;
  amplitudeKey: string;
  cohorts: string;
  commandScheduler: string;
  dashboards: DashboardLink[];
  deviceEncryptionKey: string;
  deviceEvent: string;
  deviceHealth: string;
  deviceHealthSyslogs: string;
  deviceMonitoring: string;
  devicePhotos: string;
  liveImage: string;
  deviceView: string;
  deviceApi: string;
  devicePrivacy: string;
  deviceSettings: string;
  deviceShadow: string;
  entitySearch: string;
  firmwareUpdate: string;
  firmwareUpdateService: string;
  geofenceActivation: string;
  googleMapsApiKey: string;
  modularUpdate: string;
  motionInterval: string;
  production: boolean;
  releases: string;
  settingsUpdate: string;
  versions: string;
}

export const local_saml_configuation: SamlConfiguration = {
  ssoUrl:
    'https://lytx.okta.com/app/lytx_devdevicecontrolcentersaml_1/exkn5v6v22HCig4vJ2p7/sso/saml',

  // FOR LOCAL TESTING WITH LOCAL VERSION OF AUTH SERVICE
  // ssoUrl: 'https://lytx.okta.com/app/lytx_localdevicecontrolcentersaml_1/exkn4jswg0uABiLEe2p7/sso/saml'
};

export const int_saml_configuation: SamlConfiguration = {
  ssoUrl:
    'https://lytx.okta.com/app/lytx_devdevicecontrolcentersaml_1/exkn5v6v22HCig4vJ2p7/sso/saml',
};

export const stg_saml_configuation: SamlConfiguration = {
  ssoUrl:
    'https://lytx.okta.com/app/lytx_stagedevicecontrolcentersaml_1/exkn5v6oxlUD2cLKY2p7/sso/saml',
};

export const prod_saml_configuation: SamlConfiguration = {
  ssoUrl:
    'https://lytx.okta.com/app/lytx_proddevicecontrolcentersaml_1/exkn5vjq6fLTVpwtm2p7/sso/saml',
};

export interface SamlConfiguration {
  ssoUrl: string;
}

export const environment = getEnvironment();
export const samlConfiguration = getSamlConfiguration();

function getEnvironment(): Environment {
  const env = document
    .querySelector('meta[name="environment"]')
    ?.getAttribute('value');
  switch (env) {
    case 'prod':
      return environment_prod;
    case 'stg':
      return environment_stg;
    default:
      return environment_int;
  }
}

function getSamlConfiguration(): SamlConfiguration {
  const env = document
    .querySelector('meta[name="environment"]')
    ?.getAttribute('value');
  switch (env) {
    case 'prod':
      return prod_saml_configuation;
    case 'stg':
      return stg_saml_configuation;
    case 'dev':
      return int_saml_configuation;
    default:
      return local_saml_configuation;
  }
}

export interface DashboardLink {
  name: string;
  address: string;
}
